import React, { useState } from "react";
import "../../loader.css";
const Loader = () => {
  const [switched, setSwitched] = useState(false);

  const toggleSwitch = () => {
    setSwitched(!switched);
  };

  return (
    <div className="section-center">
      <div className="section-path">
        <div className="globe">
          <div className="wrapper">
            {Array.from({ length: 16 }).map((_, index) => (
              <span key={index}></span>
            ))}
          </div>
        </div>
      </div>
      <div
        id="switch"
        className={switched ? "switched" : ""}
        onClick={toggleSwitch}
      >
        <div id="circle"></div>
      </div>
      <p>
        <span>Loading</span>
        <span>...</span>
      </p>
    </div>
  );
};

export default Loader;
